import axiosInstance from "../interceptor/instance";

export const checkStatus = async (id) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL_FILE}/status`,
    { params: { id: id } }
  );
  return response.data;
};
